import { render, staticRenderFns } from "./VisitorStatistics.vue?vue&type=template&id=122b473e&scoped=true&"
import script from "./VisitorStatistics.vue?vue&type=script&lang=js&"
export * from "./VisitorStatistics.vue?vue&type=script&lang=js&"
import style0 from "./VisitorStatistics.vue?vue&type=style&index=0&id=122b473e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122b473e",
  null
  
)

export default component.exports